"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPagesItems = getPagesItems;
exports.getSocialMediaItems = getSocialMediaItems;
exports.icons = void 0;
var _reactIntl = require("react-intl");
var _AccountCircle = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/AccountCircle"));
var _Deals = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Deals"));
var _ContactEmail = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/ContactEmail"));
var _StarFull = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/StarFull"));
var _Trip = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Trip"));
var _City = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/City"));
var _Kiwicom = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Kiwicom"));
var _CareKiwiCom = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/CareKiwiCom"));
var _Guarantee = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Guarantee"));
var _Code = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Code"));
var _Suitcase = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Suitcase"));
var _TermsAndConditions = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/TermsAndConditions"));
var _Settings = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Settings"));
var _Security = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Security"));
var _Facebook = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Facebook"));
var _Instagram = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Instagram"));
var _X = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/X"));
var _Linkedin = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Linkedin"));
var _Chat = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Chat"));
var _Exchange = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Exchange"));
var _Partners = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Partners"));
var _Youtube = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Youtube"));
const icons = exports.icons = {
  AccountCircle: _AccountCircle.default,
  Deals: _Deals.default,
  ContactEmail: _ContactEmail.default,
  Facebook: _Facebook.default,
  Instagram: _Instagram.default,
  StarFull: _StarFull.default,
  Kiwicom: _Kiwicom.default,
  CareKiwiCom: _CareKiwiCom.default,
  Guarantee: _Guarantee.default,
  Code: _Code.default,
  Suitcase: _Suitcase.default,
  TermsAndConditions: _TermsAndConditions.default,
  Security: _Security.default,
  City: _City.default,
  X: _X.default,
  Linkedin: _Linkedin.default,
  Trip: _Trip.default,
  Settings: _Settings.default,
  Chat: _Chat.default,
  Exchange: _Exchange.default,
  Partners: _Partners.default,
  Youtube: _Youtube.default
};
const companyPagesUI = {
  stories: {
    title: (0, _reactIntl.defineMessage)({
      id: "search.service.magazine"
    }),
    Icon: icons.Trip
  },
  security: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.security_title"
    }),
    Icon: icons.Security
  },
  about: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.about.title"
    }),
    Icon: icons.City
  },
  terms: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.legal.title"
    }),
    Icon: icons.TermsAndConditions
  },
  gdpr_terms: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.terms.title"
    }),
    Icon: icons.TermsAndConditions
  },
  guarantee: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.guarantee.title"
    }),
    Icon: icons.Guarantee
  },
  privacy: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.privacy.title"
    }),
    Icon: icons.Security
  },
  careers: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.careers.title"
    }),
    Icon: icons.Suitcase
  },
  media: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.media_room"
    }),
    Icon: icons.Kiwicom
  }
};
function getPagesItems(brand) {
  return Object.fromEntries(Object.entries(brand.content.pages).filter(_ref => {
    let [, page] = _ref;
    return page.enabled;
  }).map(_ref2 => {
    let [name, page] = _ref2;
    return [name, {
      ...page,
      ...companyPagesUI[name]
    }];
  }));
}

// TODO: missing translations common.instagram etc
const socialPagesUI = {
  instagram: {
    type: "instagram",
    Icon: icons.Instagram,
    label: "Instagram"
  },
  twitter: {
    type: "twitter",
    Icon: icons.X,
    label: (0, _reactIntl.defineMessage)({
      id: "common.twitter"
    })
  },
  youtube: {
    type: "youtube",
    Icon: icons.Youtube,
    label: "Youtube"
  },
  linkedin: {
    type: "linkedin",
    Icon: icons.Linkedin,
    label: " Linkedin"
  },
  blog: {
    type: "blog",
    Icon: icons.Kiwicom,
    label: "Blog"
  },
  facebook: {
    type: "facebook",
    Icon: icons.Facebook,
    label: (0, _reactIntl.defineMessage)({
      id: "common.facebook"
    })
  }
};
function getSocialMediaItems(brand) {
  return Object.entries(brand.content.media).filter(_ref3 => {
    let [, media] = _ref3;
    return media.enabled;
  }).map(_ref4 => {
    let [name, media] = _ref4;
    return {
      ...media,
      ...socialPagesUI[name]
    };
  });
}